import * as yup from 'yup';

// Validador simple de RUT chileno (formato, no dígito verificador estricto)
const RUT_REGEX = /^[0-9]{7,8}-[0-9kK]$/; // Formato: NNNNNNNN-N/kK - NNNNNNN-N/kK
const PATENTE_REGEX = /^[A-Z]{4}[0-9]{2}$/; // Formato: LLLLNN | L:Letra N:Numero

export const recepcionSchema = yup.object().shape({
  // Empresa / servicio / técnico
  id_centrocosto: yup.number()
    .required('Selecciona un centro de costo')
    .typeError('Selecciona un centro de costo'),
  id_servicios: yup.array()
    .of(yup.number())
    .min(1, "Debes seleccionar al menos un servicio")
    .required("Debes seleccionar al menos un servicio"),
  id_tecnico: yup.number()
    .required('Selecciona el técnico que recepciona')
    .typeError('Selecciona el técnico'),
  id_mecanicos: yup.array()
    .of(yup.number())
    .min(1, 'Debes asignar al menos un mecánico')
    .required('Debes asignar al menos un mecánico'),

  // Vehículo — obligatorios: patente, fechaIngreso, marca, modelo
  fechaIngreso: yup.date()
    .required('La fecha de ingreso es obligatoria')
    .typeError('Fecha inválida'),
  fechaSalida: yup.date()
    .nullable()
    .transform((v, o) => (o === '' ? null : v)),
  patente: yup
    .string()
    .transform((v) => (v || '').toUpperCase().trim())
    .required('La patente es obligatoria')
    .matches(PATENTE_REGEX, 'Formato de patente inválido (ej. ABCD12)'),
  marca: yup.string().required('La marca es obligatoria'),
  modelo: yup.string().required('El modelo es obligatorio'),
  anio: yup.number()
    .min(1850, "Año mínimo 1850")
    .max(2100, "Año máximo 2100")
    .required('El año es obligatorio'),
  nmotor: yup.string().nullable(),
  nserie: yup.string().nullable(),
  km_ingreso: yup.number()
    .min(0, 'Debe ser un valor positivo')
    .required('El kilometraje de ingreso es obligatorio'),
  // Este campo es "cuánto falta" para la próxima mantención, NO el km final
  km_prox_mantencion: yup.number()
    .nullable()
    .transform((v, o) => (o === '' ? null : v))
    .min(0, 'Debe ser un valor positivo'),
  tipo_combustible: yup.string().nullable(),
  nivel_combustible: yup.number().nullable(),
  sintomas: yup.string().nullable(),

  // Cliente — obligatorios: nombre, rut, celular
  clienteNombre: yup.string()
    .required('El nombre del cliente es obligatorio')
    .max(50, "El nombre no puede superar los 50 caracteres")
    .matches(
      /^[\p{L}\s]+$/u,
      "El nombre solo puede contener letras y espacios"
    ),
  clienteRut: yup
    .string()
    .required('El RUT es obligatorio')
    .matches(RUT_REGEX, 'Formato de RUT inválido (ej. 12345678-9)'),
  clienteCorreo: yup.string()
    .email('Correo inválido')
    .nullable(),
  clienteCelular: yup
    .string()
    .required('El celular es obligatorio')
    .max(9, "El celular no puede superar los 9 dígitos")
    .matches(/^9\d{8}$/, 'Formato inválido (ej 9 1234 5678)'),

  // Silueta / daños
  imagenVehiculoTipo: yup.string().nullable(),
  evaluacionDanos: yup.object().nullable(),
});